export const slideInRight = `
  animation-name: slidein;

  @keyframes slidein {
      0% {
        opacity: 0;
        transform: translateX(100%);
      }

      100% {
          opacity: 1;
          transform: translateX(0%);
      }
  }
`;

export const slideDown = (height) => `
  animation-name: slidedown;

  @keyframes slidedown {
      0% {
        height: 0;
        opacity: 0;
      }
      
      5% {
        height: ${height};
        opacity: 0;
      }

      70% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
  }
`;

export const slideUp = (height) => `
  animation-name: slideup;

  @keyframes slideup {
      0% {
        height: ${height};
        opacity: 1;
      }

      5% {
        height: ${height};
        opacity: 1;
      }
      70% {
        opacity: 1;
      }

      100% {
        height: 0;
        opacity: 0;
      }
  }
`;

export const positionAbsolute = `
animation-name: positionAbsolute;

@keyframes positionAbsolute {
    0% {
        position: absolute;
        opacity: 0;
    }
  
    99% {     
      position: absolute;
      opacity: 0;
    }
  
    100% {     
      position: absolute;
      opacity: 1;
    }
}
`;

export const positionRelative = `
animation-name: positionRelative;

@keyframes positionRelative {
    0% {
        position: absolute;
        opacity: 0;
    }
  
    99% {     
      position: absolute;
      opacity: 0;
    }
  
    100% {     
      position: relative;
      opacity: 1;
    }
}
`;

export const fadeDisappear = `
animation-name: fadeDisappear;

@keyframes fadeDisappear {
    0% {
      opacity: 0;
    }
    100% {     
      opacity: 0;
    }
}
`;

export const fadeAppear = `
animation-name: fadeAppear;

@keyframes fadeAppear {
    0% {
      opacity: 0;
    }
    99% {
      opacity: 0;
    }
    100% {     
      opacity: 1;
    }
}
`;
